import { atom } from "jotai";
import { ReactNode } from "react";
import { ToolkitOptions } from "../components/core/Toolkit";
import { Routes } from "../utils/clientRoutes";

export const isMobileAtom = atom<boolean>(false);
export const isAdminNavbarOpened = atom<boolean>(false);
export interface ContextMenuProps {
  items: { label: string; route?: Routes | string; callback?: () => void }[];
  position: { top: number; left: number };
}
export const contextMenuAtom = atom<ContextMenuProps | null>(null);
export const globalSpinnerAtom = atom<boolean>(true);

export const drawerAtom = atom<Record<string, boolean>>({});

export const showNavbarAtom = atom<boolean>(true);

export const toolkitAtom = atom<{
  jsx: ReactNode;
  options?: ToolkitOptions;
} | null>(null);
